import { PagedResult } from "@king-ict/eupisi-ui/models";
import { api } from "@king-ict/eupisi-ui/utils";

import { Institution, InstitutionCodeBook, InstitutionListItem } from "../../models/Institution";
import { CreateInstitutionRequest } from "../../models/Institution/CreateInstitutionRequest";
import { InstitutionExportRequest } from "./InstitutionExportRequest";
import { InstitutionSearchRequest } from "./InstitutionSearchRequest";

const institutionsUrlPrefix: string = "institutions";
const checkInstitutionsUrlPrefix = "institutions/check-from-oib"
const getFromOibInstitutionsUrlPrefix = "institutions/get-from-oib"
const institutionsHistoryUrlPrefix: string = "institutions/history";

export const createInstitutionRequest = async (request: CreateInstitutionRequest) => {
    return api.put(
        institutionsUrlPrefix,
        request
    ) as Promise<string>;
};

export const createInstitutionHeaderRequest = async (oib: string) => {
  return api.put(
    `${institutionsUrlPrefix}/create/${oib}`,
    oib
  ) as Promise<number>;
};

export const getInstitutionRequest = async (request: number) => {
    return api.get(
        `${institutionsUrlPrefix}/${request}`,
        request
    ) as Promise<Institution>;
}

export const getInstitutionHistoryRequest = async (request: number, date: string) => {
  return api.get(
    `${institutionsHistoryUrlPrefix}/${request}/${date}`,
    request
  ) as Promise<Institution>;
}

export const getAndCheckInstitutionRequest = async (request: number) => {
  return api.get(
    `${checkInstitutionsUrlPrefix}/${request}`,
    request
  ) as Promise<Institution>;
}

export const getInstitutionFromOibRequest = async (oib: string) => {
  return api.get(
    `${getFromOibInstitutionsUrlPrefix}/${oib}`,
    oib
  ) as Promise<Institution>;
}

export const searchInstitutionsCodeBook = async (search: string, municipalityIds: number[] | undefined, countyIds: number[] | undefined) => {
  let request: any = { search: search }
  let url = `${institutionsUrlPrefix}?search=${search}`;
  
  if (municipalityIds) {
    request.municipalityIds = municipalityIds;
  }

  if (countyIds) {
    request.countyIds = countyIds;
  }
  return api.get(url, request) as Promise<InstitutionCodeBook[]>;
}

export const searchInstitutions = async (request: InstitutionSearchRequest) => {
  var result = await (api.get(
    institutionsUrlPrefix + "/search",
    request
  ) as Promise<PagedResult<InstitutionListItem>>);
  
  return result;
}

export const exportInstitutions = async (request: InstitutionExportRequest) => {
  var result = await (api.download(
    institutionsUrlPrefix + "/export",
    "get",
    request
  ) as Promise<unknown>);
  return result;
};

